export class JoinValidator {
    private _isEmailExist: boolean = false;
    private _isEmailValid: boolean = false;

    private _isPasswordExist: boolean = false;
    private _isPasswordValid: boolean = false;
    private _isPasswordCorrect: boolean = false;
    private _isPasswordCorrectAndValid: boolean = false;

    get isEmailExist(): boolean {
        return this._isEmailExist;
    }

    get isEmailValid(): boolean {
        return this._isEmailValid;
    }

    get isPasswordExist(): boolean {
        return this._isPasswordExist;
    }

    get isPasswordValid(): boolean {
        return this._isPasswordValid;
    }

    get isPasswordCorrect(): boolean {
        return this._isPasswordCorrect;
    }

    public checkEmail(email: string): void {
        this._isEmailExist = !(email == undefined || email.length == 0);

        if (this._isEmailExist) {
            this._isEmailValid = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(email);
        }
    }

    public checkPassword(password: string, passwordConfirm?: string): void {
        this._isPasswordExist = !(password == undefined || password.length == 0);
        this._isPasswordValid = /^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z0-9.!@#$%&'*+/=?^_`{|}~-]{6,}/i.test(password);

        if (this._isPasswordExist) {
            this._isPasswordCorrect = password == passwordConfirm;
            this._isPasswordCorrectAndValid = (this._isPasswordCorrect && this._isPasswordValid);
        }
    }

    public isValid(): boolean {
        return this._isEmailValid && this._isPasswordCorrectAndValid;
    }
}
